import { useState, useRef } from "react";
import BlueprintHover from "./BlueprintHover";
import { SectionLabel, CtaButton, Reveal, NC, HEADSHOT_URL } from "./shared";

const CREDS = [
  ["COMPANY", "Shoreline Mortgage Group"],
  ["NMLS#", "1425493"],
  ["CO. NMLS#", null],
  ["LICENSED IN", "Florida, Pennsylvania"],
];

export default function HostSection() {
  const [hover, setHover] = useState(false);
  const [mouse, setMouse] = useState({ x: 0, y: 0 });
  const panelRef = useRef(null);
  const isFine = typeof window !== "undefined" && window.matchMedia("(pointer: fine)").matches;

  const onMove = (e) => {
    const r = panelRef.current.getBoundingClientRect();
    setMouse({ x: ((e.clientX - r.left) / r.width - 0.5) * 2, y: ((e.clientY - r.top) / r.height - 0.5) * 2 });
  };

  return (
    <section id="host" className="py-24 lg:py-36 px-6 lg:px-10 bg-[#00224F]/30" data-testid="host-section">
      <div className="max-w-6xl mx-auto">
        <Reveal>
          <SectionLabel n="005" text="YOUR HOST" />
        </Reveal>
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          <Reveal>
            <div
              ref={panelRef}
              onMouseEnter={() => isFine && setHover(true)}
              onMouseLeave={() => setHover(false)}
              onMouseMove={isFine ? onMove : undefined}
              className={`relative bg-[#00224F] border border-white/10 overflow-hidden ${!isFine ? "pulse-accent border-[#0162CA]/60" : ""}`}
              style={{ aspectRatio: "4/5" }}
              data-testid="host-portrait-panel"
            >
              <img
                src={HEADSHOT_URL}
                alt="Josh Bartlett, Branch Manager, Shoreline Mortgage Group"
                className="absolute inset-0 w-full h-full object-cover transition-opacity duration-500"
                style={{ opacity: hover ? 0.25 : 1 }}
              />
              <div
                className="absolute inset-0 transition-opacity duration-500 pointer-events-none"
                style={{
                  opacity: hover ? 1 : 0,
                  background: "radial-gradient(circle at center, rgba(1,98,202,0.35) 0%, transparent 70%)",
                }}
              />
              {isFine && <BlueprintHover active={hover} mouse={mouse} />}
              <span className="reg-mark top-3 left-3 border-t-2 border-l-2" />
              <span className="reg-mark top-3 right-3 border-t-2 border-r-2" />
              <span className="reg-mark bottom-3 left-3 border-b-2 border-l-2" />
              <span className="reg-mark bottom-3 right-3 border-b-2 border-r-2" />
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <h2 className="font-black uppercase text-3xl md:text-4xl tracking-tight leading-tight">
              GUIDANCE FROM SOMEONE WHO WORKS INSIDE THE PROCESS.
            </h2>
            <div className="h-px bg-[#0162CA] w-20 my-8" />
            <div className="space-y-5 text-white/65 text-[15px] leading-[1.8]">
              <p>
                I've spent 20+ years in and around the mortgage industry, and today I lead the Shoreline branch,
                serving buyers across Florida and Pennsylvania. This work is the daily job — reading files,
                structuring transactions, and walking people through decisions that deserve more than a quick quote.
              </p>
              <p>
                I built this class because buyers exploring VA-backed financing kept arriving with a rate quote and
                no explanation of how the rest of the deal fit together. I'm known for taking the time to look at how
                the pieces of a transaction interact — property, entitlement questions, existing obligations,
                cash-to-close — because that's where the real answers live.
              </p>
              <p>
                On the class, I'll teach the Better Deal Method™ — Clarify → Structure → Guide — and answer your
                questions live. What I won't do: approve anyone, quote a rate or payment, or pressure anyone into an
                application. This is education, and the next step is always yours to choose.
              </p>
            </div>
            <div className="grid grid-cols-2 border border-[#404653]/50 mt-10">
              {CREDS.map(([label, value], i) => (
                <div key={label} className={`p-4 ${i % 2 === 0 ? "border-r" : ""} ${i < 2 ? "border-b" : ""} border-[#404653]/50`}>
                  <p className="font-mono-strict text-[10px] tracking-[0.25em] text-white/35 mb-1.5">{label}</p>
                  <p className="text-sm font-semibold">{value || <NC label="COMPANY NMLS" />}</p>
                </div>
              ))}
            </div>
            <div className="mt-8">
              <CtaButton testId="host-cta" />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
